import { cva } from "class-variance-authority";

import { cn } from "@/lib/tailwind";
import Loader from "./Loader";
import style from "./style.module.css";
import { ButtonProps } from "./types";

export const buttonCva = cva(
  "rounded-none border-2 border-black px-5 py-3 text-[0.75rem] font-medium outline-none transition-all ease-in-out focus-visible:rounded-none active:rounded-none sm:px-10 sm:py-4 sm:text-sm md:px-12 md:py-4",
  {
    variants: {
      variant: {
        text: "border-white bg-white text-black",
        link: "border-none bg-none px-0 py-0 text-black underline underline-offset-2 sm:px-0 sm:py-0 md:px-0 md:py-0",
        outlined:
          "bg-transparent text-black focus-visible:bg-black focus-visible:text-white active:bg-transparent active:text-black",
        contained:
          "bg-black text-white focus-visible:border-2 focus-visible:border-black focus-visible:bg-transparent focus-visible:text-black",
      },
      disabled: {
        false: "opacity-100",
        true: "cursor-not-allowed border-transparent bg-tertiary-9 no-underline",
      },
    },
    defaultVariants: { disabled: false, variant: "contained" },
  },
);

// text: "border-white bg-white text-black hover:bg-transparent hover:text-white hover:ring-white",
// link: "border-none bg-none px-0 py-0 text-black underline underline-offset-2 sm:px-0 sm:py-0 md:px-0 md:py-0",
// outlined:
//   "bg-transparent text-black hover:bg-black hover:text-white focus-visible:bg-black focus-visible:text-white active:bg-transparent active:text-black",
// contained:
//   "bg-black text-white hover:bg-transparent hover:text-black focus-visible:border-2 focus-visible:border-black focus-visible:bg-transparent focus-visible:text-black active:bg-black active:text-white",

const Button = ({
  variant,
  children,
  disabled,
  className,
  isLoading,
  activateProgressOverlay,
  ...restProps
}: ButtonProps) => {
  const classes = cn(
    buttonCva({ variant, disabled }),
    isLoading && "pointer-events-none",
    className,
    activateProgressOverlay ? `${style["overlay"]}` : "",
  );

  return (
    <button type="button" disabled={disabled} className={classes} {...restProps}>
      {activateProgressOverlay ? (
        <span className="relative z-[1]">{isLoading ? <Loader /> : children}</span>
      ) : isLoading ? (
        <Loader />
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
